import { ErrorHandler, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PdfViewerModule } from 'ng2-pdf-viewer';

import { ApplicationContainerComponent } from './components/application-container/application-container.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { ExportToExcelComponent } from './components/export-to-excel/export-to-excel.component';
import { FooterComponent } from './components/footer/footer.component';
import { FullScreenComponent } from './components/fullscreen/fullscreen.component';
import { HeaderComponent } from './components/header/header.component';
import { LoaderBarComponent } from './components/loader-bar/loader-bar.component';
import { HorizontalMenuComponent } from './components/menu/horizontal-menu/horizontal-menu.component';
import { DateInputConverterDirective } from './directives/date-input-converter.directive';
import { MyngxtableComponent } from './components/myngxtable/myngxtable.component';
import { NotesComponent } from '../shared/notes/notes/notes.component';
import { NotFoundComponent } from './components/errors/not-found/not-found.component';
import { ReportIframeComponent } from './components/report-iframe/report-iframe.component';
import { TestBannerComponent } from './components/test-banner/test-banner.component';
import { UserMenuComponent } from './components/user-menu/user-menu.component';
import { ApplicationSettingsService } from './components/application-settings/application-settings.service';
import { AgmCoreModule } from '@agm/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { CalendarModule } from 'angular-calendar';
import { FileUploadModule } from 'ng2-file-upload';
import { LoadingModule } from 'ngx-loading';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PipesModule } from './pipes/pipes.module';
import { ApplicationSettingsComponent } from './components/application-settings/application-settings.component';
import { SideNavComponent } from './components/menu/side-nav/side-nav.component';
import { SideNavItemComponent } from './components/menu/side-nav/side-nav-item/side-nav-item.component';
import { UnauthorizedComponent } from './components/unauthorized/unauthorized.component';
import { ApplicationSelectComponent } from './components/header/application-select/application-select.component';
import { ErrorHandlerService } from './services/error-handler.service';
import { LoggingService } from './services/logging.service';
import { TelerikReportingModule } from '@progress/telerik-angular-report-viewer';
import { ReportViewerComponent } from './components/report-viewer/report-viewer.component';
import { ContactListComponent } from './components/contacts/contact-list/contact-list.component';
import { ContactNavComponent } from './components/contacts/contact-nav/contact-nav.component';
import { ContactInfoComponent } from './components/contacts/contact-nav/contact-info/contact-info.component';
import { ContactDetailsComponent } from './components/contacts/contact-details/contact-details.component';
import { ContactService } from './components/contacts/contact.service';
import { TextMaskModule } from 'angular2-text-mask';
import { ContactInfoCategoryListsComponent } from './components/contacts/contact-nav/contact-info-category-lists/contact-info-category-lists.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { CompanySearchService } from '../fleet-manager/company-search-bar/company-search.service';
import { RemindersComponent } from './components/reminders/reminders.component';
import { RemindersService } from './components/reminders/reminders.service';
import { NewReminderModalComponent } from './components/reminders/new-reminder-modal/new-reminder-modal.component';
import { SessionTimerComponent } from './components/session-timer/session-timer.component';
import { NewContactModalComponent } from './components/contacts/new-contact-modal/new-contact-modal.component';
import { RequestQueueingTestComponent } from './components/header/request-queueing-test/request-queueing-test.component';
import { SsnInputComponent } from './components/contacts/contact-details/ssn-input/ssn-input.component';
import { PageUserListComponent } from './components/header/page-user-list/page-user-list.component';
import { UserPageTrackingComponent } from './components/user-tracking/user-page-tracking/user-page-tracking.component';
import { UserPageHistoryComponent } from './components/user-tracking/user-page-history/user-page-history.component';
import { TelerikReportService } from './telerik/services/telerikReport.service';
import { SideNavSignalRService } from './components/menu/side-nav/side-nav-item/side-nav-signalr.service';

import { ReportGeneratorComponent } from './components/report-generator/report-generator.component';
import { ReportGeneratorContentComponent } from './components/report-generator/report-generator-content/report-generator-content.component';
import { ReportPreviewComponent } from './components/report-generator/report-generator-content/report-preview/report-preview.component';
import { ReportVersionDropdownComponent } from './components/report-generator/report-generator-content/report-preview/report-version-dropdown/report-version-dropdown.component';
import { ContactLicenseDetailModalComponent } from './components/contacts/contact-details/contact-license-detail-modal/contact-license-detail-modal.component';
import { ReportTreeComponent } from './components/reports/report-tree/report-tree.component';
import { ReportTreeItemComponent } from './components/reports/report-tree/report-tree-item/report-tree-item.component';
import { ReportsService } from './components/reports/reports.service';
import { ReportTypeListComponent } from './components/reports/report-type-list/report-type-list.component';
import { ReportTypeRolesComponent } from './components/reports/report-type-roles/report-type-roles.component';
import { DivisionService } from './services/division.service';
import { UploadViewEditDocumentModalComponent } from './components/documents/upload-view-edit-document-modal/upload-view-edit-document-modal.component';
import { UploadDocumentComponent } from './components/documents/upload-document/upload-document.component';
import { DocumentNoteDataTableComponent } from './components/documents/document-note-data-table/document-note-data-table.component';

@NgModule({
  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    RouterModule,
    // BrowserAnimationsModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDe_oVpi9eRSN99G4o6TwVjJbFBNr58NxE'
    }),
    CalendarModule.forRoot(),
    PerfectScrollbarModule,
    MultiselectDropdownModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    NgxChartsModule,
    PipesModule,
    LoadingModule,
    FileUploadModule,
    TelerikReportingModule,
    TextMaskModule,
    NgSelectModule,
    PdfViewerModule,
  ],
  entryComponents: [
    NewReminderModalComponent,
    ReportPreviewComponent,
  ],
  declarations: [
    ApplicationContainerComponent,
    ApplicationSelectComponent,
    ApplicationSettingsComponent,
    BreadcrumbComponent,
    ConfirmDialogComponent,
    DateInputConverterDirective,
    FooterComponent,
    ExportToExcelComponent,
    FullScreenComponent,
    HeaderComponent,
    HorizontalMenuComponent,
    LoaderBarComponent,
    MyngxtableComponent,
    NotesComponent,
    NotFoundComponent,
    ReportIframeComponent,
    ReportViewerComponent,
    SessionTimerComponent,
    SideNavComponent,
    SideNavItemComponent,
    TestBannerComponent,
    UnauthorizedComponent,
    UserMenuComponent,
    ContactListComponent,
    ContactNavComponent,
    ContactInfoComponent,
    ContactDetailsComponent,
    ContactInfoCategoryListsComponent,
    NewContactModalComponent,
    RequestQueueingTestComponent,
    SsnInputComponent,
    PageUserListComponent,
    UserPageTrackingComponent,
    UserPageHistoryComponent,
    RemindersComponent,
    NewReminderModalComponent,
    ReportGeneratorComponent,
    ReportGeneratorContentComponent,
    ReportPreviewComponent,
    ReportVersionDropdownComponent,
    ContactLicenseDetailModalComponent,
    ReportTreeComponent,
    ReportTreeItemComponent,
    ReportTypeListComponent,
    ReportTypeRolesComponent,
    UploadViewEditDocumentModalComponent,
    UploadDocumentComponent,
    DocumentNoteDataTableComponent,
  ],
  exports: [
    HeaderComponent,
    NotFoundComponent,
    ConfirmDialogComponent,
    BreadcrumbComponent,
    ExportToExcelComponent,
    FooterComponent,
    FullScreenComponent,
    HorizontalMenuComponent,
    ReportIframeComponent,
    UserMenuComponent,
    MyngxtableComponent,
    LoaderBarComponent,
    NotesComponent,
    DateInputConverterDirective,
    TestBannerComponent,
    ApplicationContainerComponent,
    ApplicationSettingsComponent,
    SideNavComponent,
    UnauthorizedComponent,
    ReportViewerComponent,
    ContactListComponent,
    ContactNavComponent,
    ContactInfoComponent,
    ContactDetailsComponent,
    ContactInfoCategoryListsComponent,
    NewContactModalComponent,
    RemindersComponent,
    NewReminderModalComponent,
    ReportGeneratorComponent,
    ReportGeneratorContentComponent,
    ReportVersionDropdownComponent,
    ReportPreviewComponent,
    ReportTreeComponent,
    ReportTypeListComponent,
    ReportTypeRolesComponent,
    UploadDocumentComponent,
    UploadViewEditDocumentModalComponent,
    ContactLicenseDetailModalComponent,
  ],
  providers: [
    ApplicationSettingsService,
    ContactService,
    LoggingService,
    CompanySearchService,
    TelerikReportService,
    RemindersService,
    SideNavSignalRService,
    ReportsService,
    DivisionService,
    { provide: ErrorHandler, useClass: ErrorHandlerService }
  ]
})
export class CoreModule { }



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts